import { getRemainingDays } from "./myAccountUtils";

export const addDaysSuffix = (date: Date): string => {
	const _days = getRemainingDays(date);
	return _days > 1 ? `${_days} Days` : "1 Day";
};
